import agent from "./common";
/**
 * 根据公司Id查询
 * @param {*} params
 */
const GetByCompId = (params) => {
  let p = {
    url: "/api/release/GetByCompId",
    method: "post",
    ...params,
  };
  //console.error('GetByCompId----',params)
  return agent.request(p);
};
/**
 * 根据代理Id分页查询
 * @param {*} params
 */
const GetByAgent = (params) => {
  let p = {
    url: "/api/release/GetByAgent",
    method: "post",
    ...params,
  };
  return agent.request(p);
};
const GetOne = (params) => {
  return agent.request({
    url: "/api/release/",
    method: "get",
    ...params,
  });
};
/**
 * 添加
 * @param {*} params
 */
const Add = (params) => {
  console.error("add---", params);
  let p = {
    url: "/api/release",
    method: "post",
    ...params,
  };
  return agent.request(p);
};
/**
 * 编辑
 * @param {*} params
 */
const Edit = (params) => {
  let p = {
    url: "/api/release",
    method: "put",
    ...params,
  };
  return agent.request(p);
};
/**
 * 删除
 * @param {*} params
 */
const Remove = (params) => {
  let p = {
    url: "/api/release",
    method: "delete",
    ...params,
  };
  return agent.request(p);
};

export default {
  GetByCompId,
  GetOne,
  Add,
  Edit,
  Remove,
  GetByAgent,
};
